export { getBikingQuestion, BikingAnswer } from './BikingFaq';
